import { LoadingButton } from '@mui/lab';
import {
    Dialog,
    DialogContent,
    DialogTitle,
    Stack,
    Button,
    IconButton,
    Typography
} from '@mui/material';
import { FC, useState } from 'react';
import { toast } from 'react-toastify';
import DoneIcon from '@mui/icons-material/Done';
import CloseIcon from '@mui/icons-material/Close';
import { DeleteIcon } from '../../../vectors/index';
import { useDeleteRockerboxApplicant } from '../hooks/useDeleteRockerboxApplicant';
import DeleteIcon2 from '@mui/icons-material/Delete';

type DeleteRockerboxApplicatntProps = {
    handleClose: () => void;
    item: any;
};

const DeleteRockerboxApplicatnt: FC<DeleteRockerboxApplicatntProps> = ({
    handleClose,
    item,
}) => {

    const [errorText, setErrorText] = useState('')
    const { deleteApplicant, isdeleteApplicantLoading } = useDeleteRockerboxApplicant({ setErrorText })

    const handleSave = () => {
        const options = {
            onSuccess: (data: { message: string }) => {
                toast.success(data.message)
                handleClose();
            },
        };

        deleteApplicant({ application_id: item?.id }, options)
        // handleClose();
        // toast.success('Pay rate updated successfully');
        // handleClose();
    };

    return (
        <Dialog
            open
            onClose={handleClose}
            maxWidth="xs"
            fullWidth
        >
            <DialogTitle>
                <IconButton sx={{ position: 'absolute', top: 5, right: 5 }} onClick={handleClose}>
                    <CloseIcon />
                </IconButton>
                <br />
                <DeleteIcon />
                <br />
                <Typography variant="h4" m={2} >
                    Are you sure you would like to delete this applicant from your WOTC Qualified list? This action cannot be undone.
                </Typography>
            </DialogTitle>
            <DialogContent>
                <Stack alignItems="center" spacing={0} mt={5} mb={5}>
                    <Typography sx={{ fontStyle: 'italic', fontSize: "14px" }}>
                        Reasons to delete a candidate might include:
                    </Typography>
                    <Typography sx={{ fontStyle: 'italic', fontSize: "14px" }}>
                        - Hired but never started
                    </Typography>
                    <Typography sx={{ fontStyle: 'italic', fontSize: "14px" }}>
                        - Offer sent but never accepted
                    </Typography>
                    <Typography sx={{ fontStyle: 'italic', fontSize: "14px" }}>
                        - Hired but no longer employe
                    </Typography>
                </Stack>
                <LoadingButton
                    loading={isdeleteApplicantLoading}
                    disabled={isdeleteApplicantLoading}
                    fullWidth
                    startIcon={<DeleteIcon2 />}
                    variant="contained" color="error" onClick={handleSave}>
                    Delete
                </LoadingButton>
            </DialogContent>
        </Dialog>
    );
};

export default DeleteRockerboxApplicatnt;
